import BillingSubscriptionComponent from '../ui-components/BillingSubscriptionComponent';
import { Alert, Button, Stack } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

const SubscriptionPage = () => {
    const history = useHistory();
    const location = useLocation();
    const returningToOnboarding = sessionStorage.getItem('synergist:onboardingBillingReturn') === 'true';
    const billingResult = new URLSearchParams(location.search).get('billing');
    const resume = () => {
        sessionStorage.removeItem('synergist:onboardingBillingReturn');
        history.push('/Onboarding');
    };
    // no need for onlyForRole; this is protected at the app menu level
    return <Stack spacing={2}>
        {returningToOnboarding && <Alert severity={billingResult === 'cancelled' ? 'warning' : 'info'} action={<Button variant="contained" onClick={resume} sx={{ minHeight: 44 }}>Resume setup</Button>}>{billingResult === 'cancelled' ? 'Checkout was cancelled. Your onboarding progress is still saved.' : 'Payment may take a moment to confirm. Return to setup to refresh the activation status.'}</Alert>}
        <BillingSubscriptionComponent />
    </Stack>
};

export default SubscriptionPage;
